if (!customElements.get('sticky-atc-bar-minimalist')) {
  customElements.define(
    'sticky-atc-bar-minimalist',
    class StickyAtcBarMinimalist extends HTMLElement {
      constructor() {
        super();

        this.classes = {
          isOpen: 'sticky-atc-bar--show',
        };

        this.currentVariant = null;
        this.basePrice = null;
        this.addonState = {};

        this.submitEl.addEventListener('click', this.onClick.bind(this));
      }

      get submitEl() {
        return (this._submitEl = this._submitEl || this.querySelector('[type="submit"]'));
      }

      get imageEl() {
        return (this._imageEl = this._imageEl || this.querySelector('.sticky-atc-bar__product-image'));
      }

      connectedCallback() {
        this.productFormActions = document.querySelector('.main-product-form');
        this.mainProductInfo = document.querySelector('product-info');

        this.init();

        const selectedVariantEl = document.querySelector('variant-selects [data-selected-variant]');
        if (selectedVariantEl) {
          this.currentVariant = JSON.parse(selectedVariantEl.innerHTML);
          this.basePrice = this.currentVariant.price;
        }

        this.cartErrorUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, () => {
          this.resetButtonLoading();
          this.scrollToTop(this.productFormActions);
        });

        this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, () => {
          this.resetButtonLoading();
        });
      }

      disconnectedCallback() {
        if (this.cartErrorUnsubscriber) {
          this.cartErrorUnsubscriber();
        }

        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      init() {
        if (!this.productFormActions) {
          this.classList.remove(this.classes.isOpen);
          return;
        }

        window.addEventListener('scroll', () => {
          this.classList.toggle(this.classes.isOpen, window.scrollY > 0);
        }, { passive: true });

        this.syncWithMainProductForm();
      }

      onClick() {
        this.submitEl.setAttribute('aria-disabled', 'true');
        this.submitEl.classList.add('btn--loading');
      }

      resetButtonLoading() {
        this.submitEl.removeAttribute('aria-disabled');
        this.submitEl.classList.remove('btn--loading');
      }

      scrollToTop(target, offset = 200) {
        const scrollIntoView = (selector, offset) => {
          window.scrollTo({
            behavior: 'smooth',
            top: selector.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset,
          });
        };

        scrollIntoView(target, offset);
      }

      updateButton(disable = true, text, modifyClass = true) {
        const addButton = this.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('span');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = FoxTheme.variantStrings.addToCartShort;
        }
      }

      updatePrice(variant) {
        const classes = {
          onSale: 'f-price--on-sale',
          soldOut: 'f-price--sold-out',
        };
        const selectors = {
          priceWrapper: '.f-price',
          salePrice: '.f-price-item--sale',
          compareAtPrice: ['.f-price-item--regular'],
          unitPriceWrapper: '.f-price__unit-wrapper',
        };
        const moneyFormat = FoxTheme.settings.moneyFormat;
        const { priceWrapper, salePrice, unitPriceWrapper, compareAtPrice } = FoxTheme.utils.queryDomNodes(
          selectors,
          this
        );
        const unitPrice = unitPriceWrapper.querySelector('.f-price__unit');

        const { compare_at_price, price, unit_price_measurement } = variant;

        if (compare_at_price && compare_at_price > price) {
          priceWrapper.classList.add(classes.onSale);
        } else {
          priceWrapper.classList.remove(classes.onSale);
        }

        if (!variant.available) {
          priceWrapper.classList.add(classes.soldOut);
        } else {
          priceWrapper.classList.remove(classes.soldOut);
        }

        if (salePrice) salePrice.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);

        if (compareAtPrice && compareAtPrice.length && compare_at_price > price) {
          compareAtPrice.forEach(
            (item) => (item.innerHTML = `<s>${FoxTheme.Currency.formatMoney(compare_at_price, moneyFormat)}</s>`)
          );
        } else {
          compareAtPrice.forEach((item) => (item.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat)));
        }

        if (unit_price_measurement && unitPrice) {
          unitPriceWrapper.classList.remove('hidden');
          const unitPriceContent = `<span>${FoxTheme.Currency.formatMoney(
            variant.unit_price,
            moneyFormat
          )}</span>/<span data-unit-price-base-unit>${this._getBaseUnit()}</span>`;
          unitPrice.innerHTML = unitPriceContent;
        } else {
          unitPriceWrapper.classList.add('hidden');
        }
      }

      updateImage(variant) {
        if (!variant) return;

        const wrapper = this.imageEl;
        if (!wrapper) return;

        const sectionId = this.dataset.section;
        const dataEl = document.getElementById(`VariantMediaData-${sectionId}`);

        let url = null;

        if (dataEl) {
          try {
            const data = JSON.parse(dataEl.textContent);
            const variantData = data[variant.id];
            if (variantData && variantData.urls && variantData.urls.length) {
              url = variantData.urls[0];
            }
          } catch (e) {
            // ignore parse errors, fall back below
          }
        }

        if (!url && variant.featured_image) {
          url = variant.featured_image.src;
        }

        if (!url) return;

        const img = wrapper.querySelector('img');
        if (!img) return;

        // Build a small/srcset-friendly url for the 70px slot
        const baseUrl = url.split('?')[0];
        const params = new URLSearchParams(url.split('?')[1] || '');

        const widthUrl = (w) => {
          const p = new URLSearchParams(params);
          p.set('width', w);
          return `${baseUrl}?${p.toString()}`;
        };

        img.src = widthUrl(70);
        img.srcset = `${widthUrl(70)} 70w, ${widthUrl(140)} 140w`;
      }

      getAddonTotal() {
        return Object.values(this.addonState)
          .reduce((sum, price) => sum + price, 0);
      }

      syncWithMainProductForm() {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const isMainProduct = event.data.sectionId === this.mainProductInfo.dataset.section;
          if (!isMainProduct) return;
          const variant = event.data.variant;
          this.currentVariant = variant;
          this.basePrice = variant.price;
          this.addonState = {};
          this.updatePrice(variant);
          this.updateImage(variant);
          this.updateButton(true, '', false);
          if (!variant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
          }
        });

        document.addEventListener('change', (e) => {
          if (!e.target.matches('[data-type="image-swatches"], [data-type="swatch"], [data-type="button"], [data-type="dropdown"], [data-type="radio"]')) return;
          const variant = this.currentVariant;
          if (!variant) return;
          const input = e.target;
          const name = input.name;
          const price = parseInt(input.dataset.addonPrice || 0, 10);
          this.addonState[name] = price;
          const addonTotal = this.getAddonTotal() * 100;
          this.updatePrice({ ...variant, price: this.basePrice + addonTotal });
        }, { passive: true });
      }
    }
  );
}